import { FavoriteButtonWrapperContainer } from '@cian/favorites-assign-widget';
import { Button, TooltipDesktop } from '@cian/ui-kit';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackClickOfferFavorite } from './tracking';
import { useOfferContext } from '../../../../context';
import { ControlWrapper } from 'shared/components/Controls/ControlWrapper';
import { selectIsAuthenticated } from 'shared/slices';
import { updateFavoriteStatusOffer } from 'shared/thunks/favorites/updateFavoriteStatusOffer';
import { TThunkDispatch } from 'shared/types/redux';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const FavoriteButtonContainer = () => {
  const { offer, position } = useOfferContext();

  const dispatch: TThunkDispatch = useDispatch();

  const isAuthenticated = useSelector(selectIsAuthenticated);

  const { config } = useApplicationContext();
  const isPartnersFavoritesEnabled = Boolean(config.get<boolean>('dailyrent.partners_favorites.Enabled'));

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      event.preventDefault();

      dispatch(updateFavoriteStatusOffer(offer));
      trackClickOfferFavorite(
        offer.id ?? undefined,
        position,
        offer.isFavorite ? 'remove_from_newlist' : 'add_from_newlist',
      );
    },
    [dispatch, offer, position],
  );

  const handleLogin = React.useCallback(() => {
    if (window.waitForLoginPopup) {
      window.waitForLoginPopup('favorites');
    }
  }, []);

  const button = (
    <TooltipDesktop theme="black" placement="left" title={offer.isFavorite ? 'В избранном' : 'Добавить в избранное'}>
      <Button
        data-mark="FavoritesControl"
        size="XS"
        theme="stroke_secondary"
        onClick={handleClick}
        beforeIcon={offer.isFavorite ? <IconToggleHeartOn16 color="icon-negative-default" /> : <IconToggleHeartOff16 />}
      />
    </TooltipDesktop>
  );

  if (offer.isCianPartner && !isPartnersFavoritesEnabled) {
    return null;
  }

  if (!offer.id) {
    return null;
  }

  return (
    <ControlWrapper visible={true}>
      <FavoriteButtonWrapperContainer
        offerId={offer.id}
        placement="bottom-end"
        isAuthenticated={isAuthenticated}
        onWaitForLogin={handleLogin}
      >
        {button}
      </FavoriteButtonWrapperContainer>
    </ControlWrapper>
  );
};
